import { EmbryoService } from "./../../../Services/Embryo.service";
import { Router } from "@angular/router";
import { Component, OnInit, Input, OnChanges, ViewChild } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

import { AccountSettingService } from "src/app/Services/account-setting.service";
import { MarketingService } from "src/app/Services/marketing.service";
import { SwiperOptions } from "swiper";
import { StaticPagesService } from "src/app/Services/static-pages.service";
@Component({
    selector: "embryo-HomePageTwoSlider",
    templateUrl: "./HomePageTwoSlider.component.html",
    styleUrls: ["./HomePageTwoSlider.component.scss"],
})
export class HomePageTwoSliderComponent implements OnInit, OnChanges {
    @ViewChild("bannerSwiper", { static: false }) bannerSwiper: any;
    @Input() homePageDataAds: any;
    @Input() isRTL: any;
    isDragging: boolean = false;
    AdsSlidersArray: any;
    lang: any;
    environmentVariables: any;
    swiperConfig: SwiperOptions = {
        direction: "horizontal",
        slidesPerView: "auto",
        slidesPerGroup: 1,
        keyboard: true,
        loop: true,
        loopFillGroupWithBlank: false,
        preloadImages: true,
        lazy: false,
        observer: true,
        spaceBetween: 30,
        autoHeight: true,
        pagination: {
            type: 'bullets',
            clickable: true,
        },
        centeredSlides: true,
        navigation: true,
        autoplay: {
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
        },
    };
    bannerTypes = [
        { id: 0, name: "none" },
        { id: 1, name: "Product" },
        { id: 2, name: "Subcategory" },
        { id: 3, name: "Medical" },
        { id: 4, name: "Brand" },
        { id: 5, name: "Custom List" },
        { id: 6, name: "Category" },
        { id: 7, name: "Link" },
        { id: 8, name: "vendor" },
    ];

    constructor(
        private account: AccountSettingService,
        private router: Router,
        private embryoService: EmbryoService,
        private translate: TranslateService,
        private marketingService: MarketingService,
        private confgServ: StaticPagesService,

    ) {
        embryoService.emitLang.subscribe((lang: string) => {
            this.lang = lang;
            translate.setDefaultLang(lang);
        });
        this.getInitilizingData();
    }

       getInitilizingData() {
        this.confgServ.getenvConfig().subscribe((res :any) => {
            this.environmentVariables = res;
        });
    }

    ngOnInit() {
        this.lang = localStorage.getItem("lang");
        this.translate.setDefaultLang(this.lang);
        this.AdsSlidersArray = this.homePageDataAds;
        if (this.AdsSlidersArray.length) {
            let arr: {
                item_name: any;
                item_id: any;
                price: string;
                item_brand: string;
                item_category: string;
                promotion_id: any;
                promotion_name: any;
                creative_name: any;
                creative_slot: any;
                location_id: string;
                index: any;
            }[] = [];
            let extras: any = {};
            this.AdsSlidersArray.forEach((product: any, index: number) => {
                product.nameRouter = encodeURIComponent(
                    product.name.replace(/\s/g, "-")
                );
                let obj = {
                    item_name: product.name,
                    item_id: product.id,
                    price: "",
                    item_brand: "",
                    item_category:
                        this.bannerTypes &&
                        this.bannerTypes.filter(
                            (type) => type.id == product.type
                        )[0]
                            ? this.bannerTypes.filter(
                                  (type) => type.id == product.type
                              )[0].name
                            : "",
                    promotion_id: product.item_id,
                    promotion_name: product.name,
                    creative_name: product.image,
                    creative_slot: product.order,
                    location_id: "slider",
                    index: index,
                };
                arr.push(obj);
            });

            let result = {
                event: "view_promotion",
                ecommerce: {
                    items: arr,
                    extras: this.account.googleAnalaticsUserData,
                },
            };
            // window['dataLayer'].push(result)
        }
    }

    ngOnChanges() {
        this.AdsSlidersArray = this.homePageDataAds;
        setTimeout(() => window.dispatchEvent(new Event("resize")), 500);
    }

    onSlideClick(slide: any) {
        console.log('slide ====>', slide)

        let obj = {
            item_name: slide?.name,
            item_id: slide?.id,
            price: "",
            item_brand: "",
            item_category: this.bannerTypes.filter(
                (type) => type.id == slide?.type
            )[0].name,
            promotion_id: slide?.item_id,
            promotion_name: slide?.name,
            creative_name: slide?.image,
            creative_slot: slide?.order,
            location_id: "slider",
            index: this.AdsSlidersArray.findIndex(
                (ad: any) => ad.id == slide?.id
            ),
        };
        if (slide?.type === 0) {
            return;
        } else if (slide?.type === 1) {
            this.marketingService.fbTracking("track", "ProductBanner", {
                name: slide?.banner_title || slide?.name,
            });
            this.marketingService.snapTracking("track", "AD_CLICK", {
                description: slide?.banner_title || slide?.name,
            });
 

            this.router.navigateByUrl(
                "/" +
                    this.lang +
                    `/` +
                    slide.slug
            );
        } else if (slide?.type > 1 && slide?.type <= 6 || slide?.type == 9  ) {
            const queryParamss: any = {};
            if (slide?.type === 2) {
                this.marketingService.fbTracking("track", "SubCategoryBanner", {
                    name: slide?.name,
                });
                this.marketingService.snapTracking("track", "AD_CLICK", {
                    description: slide?.name,
                });
                // queryParamss.sub_category_id = slide?.item_id;
                this.router.navigate([`/${this.lang}/product/${slide?.parent_slug}/${slide?.group_slug}/${slide?.slug}`]);
                return
            }
            if (slide?.type === 3) {
                this.marketingService.fbTracking("track", "CategoryBanner", {
                    name: slide?.name,
                });
                this.marketingService.snapTracking("track", "AD_CLICK", {
                    description: slide?.name,
                });
            }
            if (slide?.type === 4) {
                this.marketingService.fbTracking("track", "BrandBanner", {
                    name: slide?.name,
                });
                this.marketingService.snapTracking("track", "AD_CLICK", {
                    description: slide?.name,
                });
                queryParamss.brand_id = slide?.item_id;
            }
            if (slide?.type === 5) {
                this.marketingService.fbTracking("track", "ListBanner", {
                    name: slide?.name,
                });
                this.marketingService.snapTracking("track", "AD_CLICK", {
                    name: slide?.name,
                });
                queryParamss.list_ids = slide?.item_id;
                queryParamss.list_name = slide?.name;
                // this.embryoService.sendlistName(slide?.name)
            }
            if (slide?.type === 6) {
                this.marketingService.fbTracking("track", "CategoryBanner", {
                    name: slide?.name,
                });
                this.marketingService.fbTracking("track", "AD_CLICK", {
                    description: slide?.name,
                });
                // queryParamss.category_id = slide?.item_id;
                 this.router.navigate([`/${this.lang}/product/${slide?.slug}`]);
                return
            }
            if (slide?.type === 9) {
                this.marketingService.fbTracking("track", "CategoryBanner", {
                    name: slide?.name,
                });
                this.marketingService.fbTracking("track", "AD_CLICK", {
                    description: slide?.name,
                });
                queryParamss.vendor_ids = slide?.item_id;
            }
            this.router.navigate(["/" + this.lang + "/products"], {
                queryParams: queryParamss,
            });

            let result = {
                event: "view_promotion",
                ecommerce: {
                    items: obj,
                    extras: this.account.googleAnalaticsUserData,
                },
            };

            // window['dataLayer'].push(result);
        } else {
            let result = {
                event: "select_promotion",
                ecommerce: {
                    items: obj,
                    extras: this.account.googleAnalaticsUserData,
                },
            };

            // window['dataLayer'].push(result);
            if (slide?.type === 7 && !slide?.extrnal) {
                window.open(slide?.link, "_self");
            } else {
                window.open(slide?.link, "_blank");
            }
        }

    }

    setG4AClickCarousel(slider:any, index:any){
        if(this.environmentVariables?.GOOGLE_CONVERSION_ID && this.environmentVariables?.GOOGLE_ANALYTICS_ID){
            let data = {
               content_name:slider.banner_title,
               carousel_action:this.bannerTypes.filter((item:any) => item.id === slider.type)[0].name,
               position:index,
           }
           this.marketingService.GA4ClickCarouselEvent(data)
        }
    }
}
